import contact1 from './Contact 1.png';
import bggrid from './bg-grid.png'

export const contactImages = {
    contact1, bggrid
}